(function () {
  'use strict';

  /* ─── Quiz Data ───────────────────────────────────────────── */

  const AREAS = [
    { id: 'rostro',  emoji: '🧴', label: 'Rostro',          desc: 'Cuidado facial (skincare)' },
    { id: 'barba',   emoji: '🪒', label: 'Barba / Rasurado', desc: 'Cuidado del afeitado' },
    { id: 'cabello', emoji: '💆', label: 'Cabello',          desc: 'Cuero cabelludo y cabello' },
    { id: 'cuerpo',  emoji: '🚿', label: 'Cuerpo',           desc: 'Ducha y cuidado corporal' },
    { id: 'boca',    emoji: '🦷', label: 'Boca y labios',    desc: 'Higiene y cuidado bucal' },
    { id: 'manos',   emoji: '✋', label: 'Manos',            desc: 'Manos y uñas' },
    { id: 'pies',    emoji: '🦶', label: 'Pies',             desc: 'Frescura de pies' },
    { id: 'dormir',  emoji: '😴', label: 'Dormir',           desc: 'Mejora del sueño' },
  ];

  const QUIZ = {
    rostro: [
      {
        id: 'objetivo',
        q: '¿Cuál es tu objetivo principal con el rostro?',
        options: [
          { v: 'acne',          label: 'Reducir acné y granos',      concerns: ['acne'] },
          { v: 'puntos_negros', label: 'Eliminar puntos negros',     concerns: ['puntos_negros','poros'] },
          { v: 'hidratar',      label: 'Hidratar piel reseca',       concerns: ['resequedad'] },
          { v: 'manchas',       label: 'Atenuar manchas',            concerns: ['manchas'] },
          { v: 'antiedad',      label: 'Reducir arrugas / antiedad', concerns: ['envejecimiento'] },
          { v: 'mantener',      label: 'Solo mantener mi piel sana', concerns: [] },
        ],
      },
      {
        id: 'tipo_piel',
        q: '¿Cuál es tu tipo de piel?',
        options: [
          { v: 'grasa',    label: 'Grasa – brilla mucho, poros visibles' },
          { v: 'seca',     label: 'Seca – se siente tirante o se pela' },
          { v: 'mixta',    label: 'Mixta – zona T grasa, mejillas normales' },
          { v: 'sensible', label: 'Sensible – se irrita fácil' },
          { v: 'normal',   label: 'Normal – sin mayor problema' },
          { v: 'no_se',    label: 'No sé – ayúdame a determinarlo' },
        ],
      },
      {
        id: 'mini_piel',
        q: 'Al mediodía, tu cara...',
        showIf: function(a) { return a.tipo_piel === 'no_se'; },
        options: [
          { v: 'brilla_todo',   label: 'Brilla bastante en toda la cara' },
          { v: 'brilla_zona_t', label: 'Brilla solo en la frente, nariz y mentón' },
          { v: 'tira_seca',     label: 'Se siente tirante o seca' },
          { v: 'sin_cambios',   label: 'Está bien, sin cambios notables' },
        ],
      },
      {
        id: 'experiencia',
        q: '¿Cuánta experiencia tienes con skincare?',
        options: [
          { v: 'principiante', label: 'Principiante – nunca he seguido una rutina' },
          { v: 'intermedio',   label: 'Intermedio – tengo rutina básica' },
          { v: 'avanzado',     label: 'Avanzado – uso activos y sérum con frecuencia' },
        ],
      },
      {
        id: 'sensitivo',
        q: '¿Tu piel reacciona mal al alcohol o fragancias?',
        options: [
          { v: 'si',    label: 'Sí, me irrita',   opt_outs: ['no_fragancia','no_alcohol'] },
          { v: 'no',    label: 'No, sin problema' },
          { v: 'no_se', label: 'No lo sé' },
        ],
      },
      {
        id: 'ojeras',
        q: '¿Tienes ojeras o bolsas bajo los ojos?',
        options: [
          { v: 'si', label: 'Sí, bastante visibles', concerns: ['ojeras','bolsas'] },
          { v: 'no', label: 'No / apenas' },
        ],
      },
      {
        id: 'extras_faciales',
        q: '¿Te interesan extras opcionales como ice roller, bowl de hielo o guasha?',
        options: [
          { v: 'ninguno',     label: 'No, rutina básica', opt_outs: ['no_ice','no_guasha'] },
          { v: 'ice_roller',  label: 'Sí, ice roller o bowl de hielo', opt_outs: ['no_guasha'] },
          { v: 'guasha',      label: 'Sí, guasha para masaje facial',  opt_outs: ['no_ice'] },
          { v: 'todos',       label: 'Me interesan todos' },
        ],
      },
    ],

    barba: [
      {
        id: 'frecuencia',
        q: '¿Con qué frecuencia te rasuras?',
        options: [
          { v: 'diario',    label: 'A diario' },
          { v: 'varios',    label: '2–3 veces por semana' },
          { v: 'ocasional', label: 'Ocasionalmente' },
        ],
      },
      {
        id: 'problema',
        q: '¿Tienes problemas post-rasurado?',
        options: [
          { v: 'irritacion', label: 'Sí, irritación o ardor',  concerns: ['irritacion_rasurado'] },
          { v: 'encarnados', label: 'Sí, vellos encarnados',   concerns: ['vello_encarnado'] },
          { v: 'ambos',      label: 'Ambos',                    concerns: ['irritacion_rasurado','vello_encarnado'] },
          { v: 'ninguno',    label: 'No, sin problemas',        concerns: [] },
        ],
      },
      {
        id: 'producto',
        q: '¿Qué producto de afeitar prefieres?',
        options: [
          { v: 'jabon',      label: 'Jabón de afeitar – más control y duración', opt_outs: ['no_espuma'] },
          { v: 'espuma',     label: 'Espuma / gel – más rápido y fácil',          opt_outs: ['no_jabon'] },
          { v: 'cualquiera', label: 'Sin preferencia' },
        ],
      },
      {
        id: 'ice_roller',
        q: '¿Te interesa agregar un ice roller? Reduce enrojecimiento post-rasurado.',
        options: [
          { v: 'si', label: 'Sí, lo quiero probar' },
          { v: 'no', label: 'No por ahora', opt_outs: ['no_ice'] },
        ],
      },
    ],

    cabello: [
      {
        id: 'tipo',
        q: '¿Cuál es tu tipo de cabello / cuero cabelludo?',
        options: [
          { v: 'graso',  label: 'Graso – se ve grasoso al día siguiente de lavarlo' },
          { v: 'seco',   label: 'Seco – opaco o con puntas resecas' },
          { v: 'normal', label: 'Normal – sin mayor problema' },
          { v: 'mixto',  label: 'Mixto – raíces grasas, puntas secas' },
        ],
      },
      {
        id: 'problema',
        q: '¿Tienes algún problema específico?',
        options: [
          { v: 'caspa',      label: 'Caspa – copos blancos',           concerns: ['caspa'] },
          { v: 'caida',      label: 'Caída de cabello',                concerns: ['caida_cabello'] },
          { v: 'resequedad', label: 'Resequedad / frizz',              concerns: ['resequedad'] },
          { v: 'ninguno',    label: 'Ninguno, solo mantenerlo limpio', concerns: [] },
        ],
      },
      {
        id: 'formato',
        q: '¿Prefieres un 2-en-1 (shampoo + acondicionador) o productos separados?',
        options: [
          { v: 'dos_en_uno', label: 'Prefiero 2-en-1, más rápido',     opt_outs: ['no_2en1'] },
          { v: 'separados',  label: 'Prefiero separados, mejor control', opt_outs: ['no_all_in_one'] },
          { v: 'no_se',      label: 'No estoy seguro, elige por mí' },
        ],
      },
      {
        id: 'mascarilla',
        q: '¿Quieres incluir una mascarilla capilar semanal?',
        options: [
          { v: 'si', label: 'Sí, me interesa' },
          { v: 'no', label: 'No por ahora', opt_outs: ['no_mascara'] },
        ],
      },
    ],

    cuerpo: [
      {
        id: 'problema',
        q: '¿Cuál es tu principal preocupación corporal?',
        options: [
          { v: 'olor',          label: 'Olor corporal fuerte',        concerns: ['olor_corporal'] },
          { v: 'resequedad',    label: 'Piel muy reseca',             concerns: ['resequedad'] },
          { v: 'acne_corporal', label: 'Acné en espalda u otras zonas', concerns: ['acne'] },
          { v: 'ninguno',       label: 'Solo higiene general',        concerns: [] },
        ],
      },
      {
        id: 'aroma',
        q: '¿Qué tipo de aroma prefieres en body wash y desodorante?',
        options: [
          { v: 'citrico',   label: 'Cítrico / fresco' },
          { v: 'marino',    label: 'Marino / acuático' },
          { v: 'amaderado', label: 'Amaderado / elegante' },
          { v: 'mentolado', label: 'Mentolado / refrescante' },
          { v: 'dulce',     label: 'Dulce / gourmand (cacao, vainilla)' },
          { v: 'neutro',    label: 'Neutro / sin fragancia fuerte' },
          { v: 'sin_preferencia', label: 'Sin preferencia' },
        ],
      },
      {
        id: 'body_oil',
        q: '¿Te interesa agregar un aceite corporal post-ducha?',
        options: [
          { v: 'si', label: 'Sí, para mejor hidratación' },
          { v: 'no', label: 'No, con crema es suficiente', opt_outs: ['no_aceite'] },
        ],
      },
      {
        id: 'desodorante_tipo',
        q: '¿Prefieres desodorante o antitranspirante?',
        options: [
          { v: 'desodorante',     label: 'Desodorante (sin bloquear sudor)',     opt_outs: ['no_antitranspirante'] },
          { v: 'antitranspirante', label: 'Antitranspirante (bloquea sudor)' },
          { v: 'cualquiera',      label: 'Me da igual' },
        ],
      },
      {
        id: 'esponja',
        q: '¿Usas o usarías esponja de silicona en la ducha?',
        options: [
          { v: 'si', label: 'Sí, me interesa' },
          { v: 'no', label: 'No por ahora', opt_outs: ['no_esponja'] },
        ],
      },
    ],

    boca: [
      {
        id: 'problema',
        q: '¿Tienes algún problema bucal?',
        options: [
          { v: 'mal_aliento',  label: 'Mal aliento frecuente',              concerns: ['mal_aliento'] },
          { v: 'sensibilidad', label: 'Dientes sensibles al frío o calor', concerns: ['sensibilidad_dental'] },
          { v: 'labios_secos', label: 'Labios muy resecos o agrietados',   concerns: ['labios_resecos','labios_muy_secos'] },
          { v: 'ninguno',      label: 'Ninguno, rutina general',           concerns: [] },
        ],
      },
      {
        id: 'hilo',
        q: '¿Actualmente usas hilo dental o irrigador?',
        options: [
          { v: 'hilo',      label: 'Sí, hilo dental' },
          { v: 'irrigador', label: 'Sí, irrigador bucal' },
          { v: 'ninguno',   label: 'Ninguno – quiero empezar' },
        ],
      },
      {
        id: 'mentol',
        q: '¿Qué intensidad de mentol prefieres en el enjuague?',
        options: [
          { v: 'suave',    label: 'Suave – no quiero que pique' },
          { v: 'intenso',  label: 'Intenso – sensación fuerte y duradera' },
          { v: 'sin_alcohol', label: 'Priorizo sin alcohol', opt_outs: [] },
        ],
      },
    ],

    manos: [
      {
        id: 'necesidad',
        q: '¿Qué necesitas para tus manos?',
        options: [
          { v: 'unas',       label: 'Mantener uñas cortas y limpias' },
          { v: 'resequedad', label: 'Hidratar manos resecas', concerns: ['resequedad'] },
          { v: 'ambos',      label: 'Ambas cosas' },
        ],
      },
    ],

    pies: [
      {
        id: 'problema',
        q: '¿Qué problema tienes con los pies?',
        options: [
          { v: 'olor',       label: 'Olor fuerte',                    concerns: ['olor_pies'] },
          { v: 'resequedad', label: 'Piel reseca o grietas en talón', concerns: ['resequedad'] },
          { v: 'ambos',      label: 'Ambos',                          concerns: ['olor_pies','resequedad'] },
          { v: 'ninguno',    label: 'Solo prevención',                concerns: [] },
        ],
      },
    ],

    dormir: [
      {
        id: 'problema',
        q: '¿Respiras por la boca mientras duermes o roncas?',
        options: [
          { v: 'ronca', label: 'Sí, ronco',                  concerns: ['ronquidos'] },
          { v: 'boca',  label: 'Sí, respiro por la boca',    concerns: ['sequedad_nocturna'] },
          { v: 'ambos', label: 'Ambos',                      concerns: ['ronquidos','sequedad_nocturna'] },
          { v: 'no',    label: 'No, solo quiero cuidarme más', concerns: [] },
        ],
      },
      {
        id: 'mouth_tape',
        q: '¿Te interesa el mouth tape (cinta bucal) para promover respiración nasal?',
        showIf: function(a) { return a.problema === 'ronca' || a.problema === 'boca' || a.problema === 'ambos'; },
        options: [
          { v: 'si', label: 'Sí, me interesa probarlo' },
          { v: 'no', label: 'No, prefiero solo dilatadores nasales', opt_outs: ['no_mouth_tape'] },
        ],
      },
    ],
  };

  /* ─── Routine blocks / slots ───────────────────────────── */

  // Slots within each block. `step_order` defines canonical sequence;
  // numbering in the UI is RE-NUMBERED dynamically based on which slots
  // actually resolve to a product (see renderResult).

  const ROUTINE_SLOTS = [
    {
      blockId: 'skincare_am', label: 'Rutina de Mañana', emoji: '☀️',
      requires: { area: 'rostro' },
      slots: [
        { cat: 'limpiador_facial',        label: 'Limpiador facial',      step_order: 1 },
        { cat: 'esponja_silicona_facial', label: 'Exfoliante facial',     step_order: 2, optional: true, note: '2 veces por semana máximo' },
        { cat: 'contorno_ojos',           label: 'Contorno de ojos',      step_order: 3, optional: true, gateAny: ['ojeras','bolsas'] },
        { cat: 'serum',                   label: 'Sérum',                 step_order: 4, optional: true, gateAny: ['manchas','envejecimiento','acne'] },
        { cat: 'hidratante',              label: 'Hidratante',            step_order: 5 },
        { cat: 'bloqueador',              label: 'Bloqueador solar',      step_order: 6 },
        { cat: 'guasha',                  label: 'Guasha / masaje facial',step_order: 7, optional: true, gatePref: 'want_guasha' },
        { cat: 'ice_roller',              label: 'Ice roller / bowl hielo',step_order: 7, optional: true, gatePref: 'want_ice' },
      ],
    },
    {
      blockId: 'skincare_pm', label: 'Rutina de Noche', emoji: '🌙',
      requires: { area: 'rostro' },
      slots: [
        { cat: 'limpiador_facial',        label: 'Limpiador facial',  step_order: 1 },
        { cat: 'esponja_silicona_facial', label: 'Exfoliante facial', step_order: 2, optional: true, note: '2 veces por semana máximo' },
        { cat: 'contorno_ojos',           label: 'Contorno de ojos',  step_order: 3, optional: true, gateAny: ['ojeras','bolsas'] },
        { cat: 'serum',                   label: 'Sérum',             step_order: 4, optional: true, gateAny: ['manchas','envejecimiento','acne'] },
        { cat: 'hidratante',              label: 'Hidratante',        step_order: 5 },
        { cat: 'ice_roller',              label: 'Ice roller',        step_order: 6, optional: true, gatePref: 'want_ice', note: 'Reduce inflamación nocturna' },
      ],
    },
    {
      blockId: 'shave', label: 'Afeitado', emoji: '🪒',
      requires: { area: 'barba' },
      slots: [
        { cat: 'jabon_afeitar',    label: 'Jabón / espuma de afeitar', step_order: 3 },
        { cat: 'brocha_afeitar',   label: 'Brocha de afeitar',         step_order: 3, optional: true, gatePref: 'prefers_jabon' },
        { cat: 'maquina_afeitar',  label: 'Máquina de afeitar',        step_order: 4 },
        { cat: 'after_shave',      label: 'Gel after shave',           step_order: 5 },
        { cat: 'ice_roller',       label: 'Ice roller',                step_order: 6, optional: true, gatePref: 'want_ice_shave', note: 'Post-afeitado' },
        { cat: 'peine_barba',      label: 'Peine de barba',            step_order: 8, optional: true, note: 'Mantenimiento post-afeitado' },
      ],
    },
    {
      blockId: 'ducha_cabello', label: 'Ducha – Cabello', emoji: '💆',
      requires: { area: 'cabello' },
      slots: [
        { cat: 'shampoo',                  label: 'Shampoo',            step_order: 1 },
        { cat: 'esponja_silicona_cabello', label: 'Masajeador capilar', step_order: 2, optional: true, note: 'Estimula circulación capilar' },
        { cat: 'mascara_cabello',          label: 'Mascarilla capilar', step_order: 3, optional: true, note: '1 vez por semana' },
        { cat: 'acondicionador',           label: 'Acondicionador',     step_order: 4, skipIfCoveredByShampoo: true },
        { cat: 'polvo_texturizante',       label: 'Polvo texturizante', step_order: 5, optional: true, note: 'Cabello seco para dar volumen' },
      ],
    },
    {
      blockId: 'ducha_cuerpo', label: 'Ducha – Cuerpo', emoji: '🚿',
      requires: { area: 'cuerpo' },
      slots: [
        { cat: 'jabon_barra',             label: 'Jabón en barra',              step_order: 1, note: 'Primer enjuague' },
        { cat: 'esponja_corporal_diaria', label: 'Esponja de silicona diaria',  step_order: 2, optional: true, gatePref: 'want_esponja', note: 'Uso diario suave' },
        { cat: 'exfoliante_corporal',     label: 'Exfoliante o esponja exfoliante', step_order: 3, optional: true, note: '2 veces por semana máximo' },
        { cat: 'esponja_corporal_espalda',label: 'Esponja de espalda',          step_order: 4, optional: true, note: 'Alcance zonas difíciles' },
        { cat: 'body_wash',               label: 'Body wash',                   step_order: 5, note: 'Segundo enjuague' },
      ],
    },
    {
      blockId: 'after_ducha', label: 'Después de la Ducha', emoji: '✨',
      requires: { area: 'cuerpo' },
      slots: [
        { cat: 'body_lotion', label: 'Crema corporal',                 step_order: 1 },
        { cat: 'body_oil',    label: 'Aceite corporal',                step_order: 2, optional: true },
        { cat: 'desodorante', label: 'Desodorante / antitranspirante', step_order: 3 },
      ],
    },
    {
      blockId: 'oral', label: 'Cuidado Bucal', emoji: '🦷',
      requires: { area: 'boca' },
      slots: [
        { cat: 'raspador_lingual', label: 'Raspador lingual',     step_order: 1 },
        { cat: 'hilo_dental',      label: 'Hilo dental',          step_order: 2 },
        { cat: 'cepillo_dientes',  label: 'Cepillo',              step_order: 3 },
        { cat: 'pasta_dental',     label: 'Pasta dental',         step_order: 4 },
        { cat: 'enjuague_bucal',   label: 'Enjuague bucal',       step_order: 5 },
        { cat: 'balsamo_labial',   label: 'Bálsamo para labios',  step_order: 6, gateAny: ['labios_resecos','labios_muy_secos'] },
      ],
    },
    {
      blockId: 'manos', label: 'Manos', emoji: '✋',
      requires: { area: 'manos' },
      slots: [
        { cat: 'cortauñas', label: 'Cortaúñas', step_order: 1 },
      ],
    },
    {
      blockId: 'pies', label: 'Pies', emoji: '🦶',
      requires: { area: 'pies' },
      slots: [
        { cat: 'talco_pies', label: 'Desodorante / talco para pies', step_order: 1, gateAny: ['olor_pies'] },
      ],
    },
    {
      blockId: 'dormir', label: 'Para Dormir', emoji: '😴',
      requires: { area: 'dormir' },
      slots: [
        { cat: 'mouth_tape',    label: 'Mouth tape',    step_order: 1, optional: true, gatePref: 'want_mouth_tape' },
        { cat: 'tiras_nasales', label: 'Tiras nasales / dilatador', step_order: 2, gateAny: ['ronquidos','sequedad_nocturna'] },
      ],
    },
  ];

  /* ─── State ───────────────────────────────────────────────── */

  var state = {
    phase: 'disclaimer',
    selectedAreas: [],
    branchQueue: [],
    currentBranch: null,
    qIdx: 0,
    answers: {},
    recommendedVariants: [],
    slotQueue: [],
    slotIdx: 0,
    userSelections: {},
  };

  /* ─── Helpers ─────────────────────────────────────────────── */

  function normArr(v) {
    if (!v) return [];
    if (Array.isArray(v)) return v.map(function(x){ return String(x).toLowerCase(); });
    if (typeof v === 'string') {
      try { var p = JSON.parse(v); if (Array.isArray(p)) return p.map(function(x){ return String(x).toLowerCase(); }); } catch(e){}
      return [v.toLowerCase()];
    }
    return [String(v).toLowerCase()];
  }
  function normStr(v) { return v == null ? '' : String(v).toLowerCase(); }
  function uniq(arr) { return arr.filter(function(v,i,a){return a.indexOf(v)===i;}); }

  function getSkinType(rostroAnswers) {
    if (!rostroAnswers) return null;
    var t = rostroAnswers.tipo_piel;
    if (t && t !== 'no_se') return t;
    var miniMap = { brilla_todo: 'grasa', brilla_zona_t: 'mixta', tira_seca: 'seca', sin_cambios: 'normal' };
    return miniMap[rostroAnswers.mini_piel] || null;
  }

  // Per-area concerns derivation. Each area has its own mapping, so "olor"
  // under pies never collides with "olor" under cuerpo.
  function getAreaConcerns(area, areaAnswers) {
    if (!areaAnswers) return [];
    var concerns = [];
    var qList = QUIZ[area] || [];
    qList.forEach(function(q) {
      var answer = areaAnswers[q.id];
      if (!answer) return;
      var chosen = (q.options || []).find(function(o){ return o.v === answer; });
      if (chosen && Array.isArray(chosen.concerns)) {
        concerns = concerns.concat(chosen.concerns);
      }
    });
    return uniq(concerns);
  }

  // Derive user preference flags + opt-outs from all answers across all areas.
  function getUserPrefs(answers) {
    var optOuts = [];
    var wantFlags = {};

    // Helper: walk each answer and pull opt_outs from the chosen option.
    Object.keys(answers || {}).forEach(function(area) {
      var areaAns = answers[area] || {};
      var qList = QUIZ[area] || [];
      qList.forEach(function(q) {
        var ans = areaAns[q.id];
        if (!ans) return;
        var chosen = (q.options || []).find(function(o){ return o.v === ans; });
        if (chosen && Array.isArray(chosen.opt_outs)) optOuts = optOuts.concat(chosen.opt_outs);
      });
    });

    // Extra prefs that aren't opt-outs but gate optional slots:
    var rostroExtras = (answers.rostro && answers.rostro.extras_faciales) || '';
    wantFlags.want_ice    = rostroExtras === 'ice_roller' || rostroExtras === 'todos';
    wantFlags.want_guasha = rostroExtras === 'guasha'     || rostroExtras === 'todos';

    // Shave ice roller.
    wantFlags.want_ice_shave = answers.barba && answers.barba.ice_roller === 'si';

    // Body preferences.
    wantFlags.want_esponja = answers.cuerpo && answers.cuerpo.esponja === 'si';

    // Shave brocha only if jabón preferred.
    wantFlags.prefers_jabon = answers.barba && answers.barba.producto === 'jabon';

    // Mouth tape (sleep).
    wantFlags.want_mouth_tape = answers.dormir && answers.dormir.mouth_tape === 'si';

    // Fragrance prefs (body).
    var aroma = answers.cuerpo && answers.cuerpo.aroma;
    var fragrancePrefs = [];
    if (aroma && aroma !== 'sin_preferencia') {
      if (aroma === 'mentolado') fragrancePrefs = ['mentolado_suave','mentolado_intenso'];
      else fragrancePrefs = [aroma];
    }

    // Mouth rinse intensity.
    var mentol = answers.boca && answers.boca.mentol;
    var oralFragrancePrefs = [];
    if (mentol === 'suave')        oralFragrancePrefs = ['mentolado_suave'];
    else if (mentol === 'intenso') oralFragrancePrefs = ['mentolado_intenso'];
    else if (mentol === 'sin_alcohol') oralFragrancePrefs = ['sin_alcohol'];

    // Hair format prefer.
    var formato = answers.cabello && answers.cabello.formato;
    if (formato === 'separados') optOuts.push('no_2en1');
    if (formato === 'dos_en_uno') wantFlags.want_all_in_one = true;

    // Desodorante type.
    var desoTipo = answers.cuerpo && answers.cuerpo.desodorante_tipo;
    wantFlags.desodorante_tipo = desoTipo || 'cualquiera';

    // Hair type extra concern.
    var hairType = answers.cabello && answers.cabello.tipo;

    return {
      opt_outs: uniq(optOuts),
      fragrance_prefs: fragrancePrefs,
      oral_fragrance_prefs: oralFragrancePrefs,
      want_flags: wantFlags,
      hair_type: hairType,
      experience: (answers.rostro && answers.rostro.experiencia) || 'principiante',
      sensitivo: answers.rostro && answers.rostro.sensitivo === 'si',
    };
  }

  /* ─── Recommend logic ────────────────────────────────── */

  // Scoring weights.
  var W_SKIN = 3, W_HAIR = 3, W_CONCERN = 3, W_FRAGRANCE = 2,
      W_EXPERIENCE = 2, W_EXPERIENCE_FALLBACK = 1, W_GATE_MATCH = 2;

  function recommend(slot, answers, userPrefs) {
    var products = window.SHOTTY_RB_PRODUCTS || [];
    var areaAns = answers[slot.area] || {};
    var skinType = getSkinType(answers.rostro);
    var hairType = userPrefs.hair_type;
    var experience = userPrefs.experience;
    var concerns = getAreaConcerns(slot.area, areaAns);

    // Hard filter 1: category match.
    var candidates = products.filter(function(p) {
      return normArr(p.routine_category).indexOf(normStr(slot.cat)) !== -1;
    });
    if (candidates.length === 0) return [];

    // Hard filter 2: opt-outs. Discard any product that declares an opt_out_tag
    // that matches a user opt-out.
    candidates = candidates.filter(function(p) {
      var outs = normArr(p.opt_out_tags);
      for (var i = 0; i < outs.length; i++) {
        if (userPrefs.opt_outs.indexOf(outs[i]) !== -1) return false;
      }
      return true;
    });
    if (candidates.length === 0) return [];

    // Hard filter 3: stock. Drop ALL out-of-stock products. If this leaves the
    // slot empty the caller will skip it entirely (no OOS products are shown).
    candidates = candidates.filter(function(p) {
      return p.available === true && (p.stock == null || p.stock > 0);
    });
    if (candidates.length === 0) return [];

    // Hard filter 3.5: contraindications. Any product whose id is excluded by
    // an active user condition is dropped before scoring. Source of truth:
    // assets/rb-contraindications.json, generated from the Excel.
    var contraindications = window.SHOTTY_RB_CONTRAINDICATIONS || [];
    if (contraindications.length) {
      var activeConditions = [];
      if (userPrefs.sensitivo) activeConditions.push('piel_sensible');
      if (skinType === 'grasa') {
        activeConditions.push('piel_grasa');
        if (slot.area === 'rostro') activeConditions.push('piel_grasa_rostro');
      }
      if (skinType === 'seca') {
        activeConditions.push('piel_seca');
        if (slot.area === 'rostro') activeConditions.push('piel_seca_rostro');
      }
      if (concerns.indexOf('acne') !== -1 || concerns.indexOf('acne_severo') !== -1) {
        activeConditions.push('acne_inflamatorio');
      }
      if (concerns.indexOf('rosacea') !== -1) activeConditions.push('rosacea');
      if (experience === 'principiante') activeConditions.push('principiante');

      var excludedIds = {};
      contraindications.forEach(function(rule) {
        if (activeConditions.indexOf(rule.condition) === -1) return;
        if (rule.restrictToArea && rule.restrictToArea !== slot.area) return;
        (rule.excludeIds || []).forEach(function(id) { excludedIds[id] = true; });
      });
      if (Object.keys(excludedIds).length) {
        candidates = candidates.filter(function(p) { return !excludedIds[p.id]; });
        if (candidates.length === 0) return [];
      }
    }

    // Hard filter 4: for desodorante, respect desodorante_tipo preference.
    if (slot.cat === 'desodorante' && userPrefs.want_flags.desodorante_tipo === 'desodorante') {
      var filtered = candidates.filter(function(p) { return !p.is_antitranspirante; });
      if (filtered.length > 0) candidates = filtered;
    }

    // Hard filter 5: sensitive skin → prefer products without fragrance when possible.
    if (userPrefs.sensitivo && slot.cat !== 'desodorante') {
      var senseFriendly = candidates.filter(function(p) {
        var fp = normArr(p.fragrance_profile);
        return fp.indexOf('sin_fragancia') !== -1 || fp.indexOf('neutro') !== -1 || fp.length === 0;
      });
      if (senseFriendly.length > 0) candidates = senseFriendly;
    }

    // Hard filter 6: face slots respect skin_type_fit when declared. Products
    // whose skin_type_fit is non-empty AND does NOT include the user's skin
    // type are dropped. Empty skin_type_fit means "fits any" (tolerant).
    // Soft fallback: if applying this filter would leave 0 candidates, we
    // skip it rather than block the slot — the scorer still penalizes
    // mismatched products via W_SKIN.
    var FACE_SLOTS_HARD_SKIN = { limpiador_facial: 1, hidratante: 1, bloqueador: 1 };
    if (skinType && FACE_SLOTS_HARD_SKIN[slot.cat]) {
      var byType = candidates.filter(function(p) {
        var fit = normArr(p.skin_type_fit);
        return fit.length === 0 || fit.indexOf(normStr(skinType)) !== -1;
      });
      if (byType.length > 0) candidates = byType;
    }

    // Scoring.
    var scored = candidates.map(function(p) {
      var score = 0;
      var skinFit  = normArr(p.skin_type_fit);
      var hairFit  = normArr(p.hair_type);
      var targets  = normArr(p.concerns_targeted);
      var fragrance = normArr(p.fragrance_profile);

      if (skinType && skinFit.length && skinFit.indexOf(normStr(skinType)) !== -1) score += W_SKIN;
      if (hairType && hairFit.length && hairFit.indexOf(normStr(hairType)) !== -1) score += W_HAIR;
      concerns.forEach(function(c) { if (targets.indexOf(normStr(c)) !== -1) score += W_CONCERN; });

      // Fragrance preference matching.
      var fragPrefs = (slot.cat === 'enjuague_bucal') ? userPrefs.oral_fragrance_prefs : userPrefs.fragrance_prefs;
      fragPrefs.forEach(function(f) {
        if (fragrance.indexOf(normStr(f)) !== -1) score += W_FRAGRANCE;
      });

      if (normStr(p.experience_level) === normStr(experience)) score += W_EXPERIENCE;
      else if (!p.experience_level || p.experience_level === 'principiante') score += W_EXPERIENCE_FALLBACK;

      // 2-in-1 bonus if user wants it.
      if (slot.cat === 'shampoo' && userPrefs.want_flags.want_all_in_one && p.is_all_in_one) {
        score += 3;
      }

      return { p: p, score: score };
    });

    // Minimum score threshold: if top score is low it means the match is weak
    // (no concern, no skin type, no fragrance matched) — return [] to signal
    // "don't render this slot". When the user explicitly opted in via a
    // gatePref (e.g. "sí, me interesa la esponja"), drop the threshold to 0
    // so the slot still renders even if no scoring axis matched.
    var hasOptIn = !!(slot.gatePref && userPrefs.want_flags[slot.gatePref]);
    var MIN_SCORE;
    if (hasOptIn) MIN_SCORE = 0;
    else if (slot.optional || slot.cat === 'serum' || slot.cat === 'contorno_ojos') MIN_SCORE = 3;
    else MIN_SCORE = 1;
    var best = scored.reduce(function(m, s){ return s.score > m ? s.score : m; }, 0);
    if (best < MIN_SCORE) return [];

    // Sort: score desc, then step_order asc (canonical), then stock desc, then price tier preference.
    scored.sort(function(a, b) {
      if (b.score !== a.score) return b.score - a.score;
      var ao = parseInt(a.p.step_order || 99, 10);
      var bo = parseInt(b.p.step_order || 99, 10);
      if (ao !== bo) return ao - bo;
      var as = parseInt(a.p.stock || 0, 10);
      var bs = parseInt(b.p.stock || 0, 10);
      return bs - as;
    });

    return scored.slice(0, 3).map(function(s){ return s.p; });
  }

  /* ─── Slot gating ──────────────────────────────────────── */

  function slotPassesGate(slot, userPrefs, allConcerns) {
    if (slot.gateAny && Array.isArray(slot.gateAny)) {
      var match = slot.gateAny.some(function(c){ return allConcerns.indexOf(c) !== -1; });
      if (!match) return false;
    }
    if (slot.gatePref) {
      if (!userPrefs.want_flags[slot.gatePref]) return false;
    }
    return true;
  }

  /* ─── DOM helpers ─────────────────────────────────────────── */

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }
  function hide(elem) { if (elem) elem.hidden = true; }
  function show(elem) { if (elem) elem.hidden = false; }

  /* ─── Renders ─────────────────────────────────────────────── */

  function updateProgress() {
    var fill = qs('#rb-progress-fill');
    var lbl  = qs('#rb-progress-label');
    if (!fill) return;
    var pct = 0;
    var text = '';
    if (state.phase === 'areas') { pct = 5; text = 'Selecciona áreas'; }
    else if (state.phase === 'branch') {
      var totalAreas = state.selectedAreas.length;
      var doneAreas  = totalAreas - state.branchQueue.length - 1;
      var visibleQs  = getVisibleQs(state.currentBranch);
      var qPct       = visibleQs.length ? state.qIdx / visibleQs.length : 1;
      pct = Math.round(((doneAreas + qPct) / totalAreas) * 90) + 5;
      var area = AREAS.find(function(a){ return a.id === state.currentBranch; });
      text = area ? area.emoji + ' ' + area.label : '';
    }
    else if (state.phase === 'select') {
      var total = state.slotQueue.length || 1;
      pct = 90 + Math.round((state.slotIdx / total) * 10);
      var cur = state.slotQueue[state.slotIdx];
      text = cur ? cur.block.emoji + ' ' + cur.block.label + ' · paso ' + (state.slotIdx + 1) + '/' + state.slotQueue.length : '';
    }
    else if (state.phase === 'result') { pct = 100; text = 'Tu rutina lista'; }

    fill.style.width = pct + '%';
    if (lbl) lbl.textContent = (text ? text + ' · ' : '') + pct + '%';
  }

  function renderAreas() {
    var step = qs('#rb-step');
    if (!step) return;
    step.innerHTML = '';
    var eyebrow = el('p', 'rb-step__eyebrow', 'Paso 1 de 2');
    var question = el('h2', 'rb-step__question',
      '¿En qué áreas quieres mejorar?<br><small style="font-size:.65em;font-weight:500;opacity:.6">Elige todas las que apliquen</small>');

    var grid = el('div', 'rb-areas');
    AREAS.forEach(function(area) {
      var btn = el('button', 'rb-area-card');
      btn.type = 'button';
      btn.setAttribute('aria-pressed', 'false');
      btn.dataset.area = area.id;
      btn.innerHTML =
        '<span class="rb-area-card__emoji">' + area.emoji + '</span>' +
        '<span class="rb-area-card__text">' +
          '<span class="rb-area-card__label">' + area.label + '</span>' +
          '<span class="rb-area-card__desc">' + area.desc + '</span>' +
        '</span>' +
        '<span class="rb-area-card__check" aria-hidden="true">' +
          '<svg width="12" height="10" viewBox="0 0 12 10" fill="none"><path d="M1 5l3.5 3.5L11 1" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</span>';
      btn.addEventListener('click', function() {
        var pressed = btn.getAttribute('aria-pressed') === 'true';
        btn.setAttribute('aria-pressed', (!pressed).toString());
        nextBtn.disabled = !grid.querySelector('[aria-pressed="true"]');
      });
      grid.appendChild(btn);
    });

    var nav = el('div', 'rb-nav');
    var nextBtn = el('button', 'rb-btn rb-btn--primary', 'Continuar →');
    nextBtn.type = 'button';
    nextBtn.disabled = true;
    nextBtn.addEventListener('click', function() {
      var selected = Array.from(grid.querySelectorAll('[aria-pressed="true"]')).map(function(b){ return b.dataset.area; });
      state.selectedAreas = selected;
      state.branchQueue   = selected.slice();
      state.answers       = {};
      startNextBranch();
    });
    nav.appendChild(nextBtn);

    step.appendChild(eyebrow);
    step.appendChild(question);
    step.appendChild(grid);
    step.appendChild(nav);
    updateProgress();
  }

  function getVisibleQs(branch) {
    return (QUIZ[branch] || []).filter(function(q) {
      return !q.showIf || q.showIf(state.answers[branch] || {});
    });
  }

  function renderQuestion() {
    var step = qs('#rb-step');
    if (!step) return;
    step.innerHTML = '';
    var branch  = state.currentBranch;
    var qs_list = getVisibleQs(branch);
    var qData   = qs_list[state.qIdx];
    if (!qData) { startNextBranch(); return; }

    var area = AREAS.find(function(a){ return a.id === branch; });
    var eyebrow = el('p', 'rb-step__eyebrow', area ? area.emoji + ' ' + area.label : '');
    var question = el('h2', 'rb-step__question', qData.q);

    var opts = el('div', 'rb-options');
    qData.options.forEach(function(opt) {
      var btn = el('button', 'rb-option');
      btn.type = 'button';
      btn.setAttribute('aria-pressed', 'false');
      btn.innerHTML = '<span class="rb-option__radio" aria-hidden="true"></span>' + opt.label;
      btn.addEventListener('click', function() {
        opts.querySelectorAll('.rb-option').forEach(function(b){ b.setAttribute('aria-pressed','false'); });
        btn.setAttribute('aria-pressed', 'true');
        state.answers[branch] = state.answers[branch] || {};
        state.answers[branch][qData.id] = opt.v;
        setTimeout(advance, 220);
      });
      opts.appendChild(btn);
    });

    var nav = el('div', 'rb-nav');
    if (state.qIdx > 0 || state.selectedAreas.indexOf(branch) > 0) {
      var backBtn = el('button', 'rb-nav__back', '← Atrás');
      backBtn.type = 'button';
      backBtn.addEventListener('click', goBack);
      nav.appendChild(backBtn);
    }

    step.appendChild(eyebrow);
    step.appendChild(question);
    step.appendChild(opts);
    step.appendChild(nav);
    updateProgress();
  }

  function advance() {
    var branch  = state.currentBranch;
    var qs_list = getVisibleQs(branch);
    state.qIdx++;
    if (state.qIdx >= qs_list.length) startNextBranch();
    else renderQuestion();
  }

  function goBack() {
    if (state.qIdx > 0) { state.qIdx--; renderQuestion(); }
    else {
      var idx = state.selectedAreas.indexOf(state.currentBranch);
      if (idx > 0) {
        state.branchQueue.unshift(state.currentBranch);
        state.currentBranch = state.selectedAreas[idx - 1];
        var prevQs = getVisibleQs(state.currentBranch);
        state.qIdx = prevQs.length - 1;
        state.phase = 'branch';
        renderQuestion();
      } else {
        state.phase = 'areas';
        state.currentBranch = null;
        renderAreas();
      }
    }
    updateProgress();
  }

  function startNextBranch() {
    if (state.branchQueue.length === 0) {
      buildSlotQueue();
      if (state.slotQueue.length === 0) { renderResult(); return; }
      state.phase = 'select';
      state.slotIdx = 0;
      renderSlotSelection();
      return;
    }
    state.currentBranch = state.branchQueue.shift();
    state.qIdx = 0;
    state.phase = 'branch';
    renderQuestion();
  }

  /* ─── Select Phase (guided product-by-product selection) ───── */

  // userSelections is keyed by `area:cat` so the same slot (e.g. rostro:limpiador_facial)
  // asked once in the AM block is auto-reused in the PM block. Same for contorno_ojos,
  // serum, hidratante, and any other cat that repeats across blocks sharing an area.
  function selectionKey(slot) { return slot.area + ':' + slot.cat; }

  function buildSlotQueue() {
    state.slotQueue = [];
    state.slotIdx = 0;
    state.userSelections = {};

    var userPrefs = getUserPrefs(state.answers);
    var allConcerns = [];
    state.selectedAreas.forEach(function(area) {
      allConcerns = allConcerns.concat(getAreaConcerns(area, state.answers[area]));
    });
    allConcerns = uniq(allConcerns);

    var askedKeys = {};

    ROUTINE_SLOTS.forEach(function(block) {
      if (state.selectedAreas.indexOf(block.requires.area) === -1) return;

      var sorted = block.slots.slice().sort(function(a, b) {
        return (a.step_order || 99) - (b.step_order || 99);
      });

      sorted.forEach(function(slot) {
        slot.area = block.requires.area;

        // Dynamic gating per block (gates & coveredCats are checked at render time too).
        if (!slotPassesGate(slot, userPrefs, allConcerns)) return;

        var key = selectionKey(slot);
        if (askedKeys[key]) return;    // same (area, cat) already queued → auto-reuse.

        var products = recommend(slot, state.answers, userPrefs);
        if (products.length === 0) return;  // no in-stock candidates → skip.

        askedKeys[key] = true;
        state.slotQueue.push({
          block: block,       // block where the slot is first encountered (for the eyebrow)
          slot: slot,
          products: products,
          key: key,
        });
      });
    });
  }

  // Skip slots whose cat has already been covered by a prior 2-in-1 selection
  // (e.g. user picked an all-in-one shampoo → skip the acondicionador question).
  function skipCoveredSlots() {
    while (state.slotIdx < state.slotQueue.length) {
      var item = state.slotQueue[state.slotIdx];
      if (item.slot.skipIfCoveredByShampoo) {
        var shampoo = state.userSelections[item.slot.area + ':shampoo'];
        if (shampoo && shampoo.is_all_in_one &&
            normArr(shampoo.covers_slots).indexOf(item.slot.cat) !== -1) {
          state.slotIdx++;
          continue;
        }
      }
      break;
    }
  }

  function renderSlotSelection() {
    skipCoveredSlots();

    var step = qs('#rb-step');
    if (!step) return;

    var item = state.slotQueue[state.slotIdx];
    if (!item) { state.phase = 'result'; renderResult(); return; }

    step.innerHTML = '';

    var block = item.block;
    var slot = item.slot;
    var products = item.products;
    var userPrefs = getUserPrefs(state.answers);

    var isSingle = products.length === 1;
    var titleText = isSingle
      ? 'Tu ' + slot.label.toLowerCase()
      : 'Elige tu ' + slot.label.toLowerCase();
    var subtitleText = isSingle
      ? 'Esta opción coincide con tu perfil.'
      : 'Estas opciones coinciden con tu perfil. Desliza para ver todas.';
    var btnLabel = isSingle ? 'Incluir en mi rutina' : 'Elegir';

    var eyebrow = el('p', 'rb-step__eyebrow',
      block.emoji + ' ' + block.label + ' · Paso ' + (state.slotIdx + 1) + ' de ' + state.slotQueue.length);
    var title = el('h2', 'rb-step__question', titleText);
    var subtitleEl = el('p', 'rb-select__subtitle', subtitleText);

    // Carousel track (horizontal scroll-snap). Arrows scroll by one card width.
    var carousel = el('div', 'rb-select__carousel' + (isSingle ? ' rb-select__carousel--single' : ''));
    var track = el('div', 'rb-select__track');

    products.forEach(function(p) {
      var card = el('div', 'rb-select-card');

      var imgWrap = el('div', 'rb-select-card__img-wrap');
      if (p.image) {
        var img = document.createElement('img');
        img.className = 'rb-select-card__img';
        img.src = p.image;
        img.alt = p.title;
        img.loading = 'lazy';
        imgWrap.appendChild(img);
      } else {
        imgWrap.appendChild(el('div', 'rb-step-card__img-placeholder', '📦'));
      }

      var badges = el('div', 'rb-select-card__badges');
      if (slot.optional) {
        badges.appendChild(el('span', 'rb-select-card__badge rb-select-card__badge--optional', 'Opcional'));
      }
      if (p.is_all_in_one) {
        badges.appendChild(el('span', 'rb-select-card__badge', '2-en-1'));
      }
      if (badges.children.length) imgWrap.appendChild(badges);

      card.appendChild(imgWrap);

      var body = el('div', 'rb-select-card__body');
      body.appendChild(el('p', 'rb-select-card__title', p.title));
      body.appendChild(el('p', 'rb-select-card__price', p.price));
      if (p.key_ingredient) {
        body.appendChild(el('p', 'rb-select-card__ingredient', '✦ ' + p.key_ingredient));
      }
      var whyText = p.why_recommended || buildAutoWhy(slot, p, state.answers, userPrefs);
      if (whyText) body.appendChild(el('p', 'rb-select-card__why', whyText));
      if (p.medical_flag) {
        body.appendChild(el('p', 'rb-select-card__why', '⚠️ Contiene activos potentes. Si tienes piel reactiva, consulta a un dermatólogo.'));
      }
      card.appendChild(body);

      var actionBtn = el('button', 'rb-select-card__action', btnLabel);
      actionBtn.type = 'button';
      (function(product) {
        actionBtn.addEventListener('click', function() {
          state.userSelections[selectionKey(slot)] = product;
          advanceSlot();
        });
      })(p);
      card.appendChild(actionBtn);

      track.appendChild(card);
    });

    carousel.appendChild(track);

    // Arrow buttons for desktop scroll (only when >1 product).
    if (!isSingle) {
      var leftArrow = el('button', 'rb-select__arrow rb-select__arrow--left', '‹');
      leftArrow.type = 'button';
      leftArrow.setAttribute('aria-label', 'Anterior');
      leftArrow.addEventListener('click', function() {
        var card = track.querySelector('.rb-select-card');
        var step = card ? card.getBoundingClientRect().width + 16 : 240;
        track.scrollBy({ left: -step, behavior: 'smooth' });
      });

      var rightArrow = el('button', 'rb-select__arrow rb-select__arrow--right', '›');
      rightArrow.type = 'button';
      rightArrow.setAttribute('aria-label', 'Siguiente');
      rightArrow.addEventListener('click', function() {
        var card = track.querySelector('.rb-select-card');
        var step = card ? card.getBoundingClientRect().width + 16 : 240;
        track.scrollBy({ left: step, behavior: 'smooth' });
      });

      carousel.appendChild(leftArrow);
      carousel.appendChild(rightArrow);

      // Hide arrows when track fits without overflow (all cards visible).
      // Re-check on window resize since layout can change between breakpoints.
      var updateArrows = function() {
        var hasOverflow = track.scrollWidth > track.clientWidth + 4;
        leftArrow.classList.toggle('rb-select__arrow--hidden', !hasOverflow);
        rightArrow.classList.toggle('rb-select__arrow--hidden', !hasOverflow);
      };
      requestAnimationFrame(updateArrows);
      window.addEventListener('resize', updateArrows);
    }

    var footer = el('div', 'rb-select__footer');

    var backBtn = el('button', 'rb-nav__back', '← Atrás');
    backBtn.type = 'button';
    backBtn.addEventListener('click', function() {
      if (state.slotIdx > 0) {
        state.slotIdx--;
        renderSlotSelection();
      } else {
        var lastArea = state.selectedAreas[state.selectedAreas.length - 1];
        state.currentBranch = lastArea;
        var prevQs = getVisibleQs(lastArea);
        state.qIdx = Math.max(0, prevQs.length - 1);
        state.phase = 'branch';
        renderQuestion();
      }
      updateProgress();
    });
    footer.appendChild(backBtn);

    if (slot.optional) {
      var skipBtn = el('button', 'rb-select__skip', 'Saltar este paso');
      skipBtn.type = 'button';
      skipBtn.addEventListener('click', function() {
        state.userSelections[selectionKey(slot)] = null;
        advanceSlot();
      });
      footer.appendChild(skipBtn);
    }

    step.appendChild(eyebrow);
    step.appendChild(title);
    step.appendChild(subtitleEl);
    step.appendChild(carousel);
    step.appendChild(footer);

    window.scrollTo({ top: 0, behavior: 'smooth' });
    updateProgress();
  }

  function advanceSlot() {
    state.slotIdx++;
    skipCoveredSlots();
    if (state.slotIdx >= state.slotQueue.length) {
      state.phase = 'result';
      renderResult();
    } else {
      renderSlotSelection();
    }
  }

  /* ─── Result Render ───────────────────────────────────────── */

  // Auto-generate the "why" line from the user's answers when why_recommended
  // is empty. Keeps the card informative.
  function buildAutoWhy(slot, product, answers, userPrefs) {
    var parts = [];
    var skinType = getSkinType(answers.rostro);
    var hairType = userPrefs.hair_type;
    var concerns = getAreaConcerns(slot.area, answers[slot.area]);

    if (skinType && normArr(product.skin_type_fit).indexOf(normStr(skinType)) !== -1) {
      parts.push('porque indicaste piel <strong>' + skinType + '</strong>');
    }
    if (hairType && normArr(product.hair_type).indexOf(normStr(hairType)) !== -1) {
      parts.push('porque indicaste cabello <strong>' + hairType + '</strong>');
    }
    var targets = normArr(product.concerns_targeted);
    var matchedConcerns = concerns.filter(function(c){ return targets.indexOf(normStr(c)) !== -1; });
    if (matchedConcerns.length > 0) {
      parts.push('ataca <strong>' + matchedConcerns.join(', ') + '</strong>');
    }
    if (product.key_ingredient) {
      parts.push('con <strong>' + product.key_ingredient + '</strong>');
    }
    if (parts.length === 0) return '';
    return 'Se recomienda ' + parts.join(', ') + '.';
  }

  // Re-expand the user's selections across all applicable blocks. A single
  // selection for (rostro, limpiador_facial) populates both AM and PM blocks
  // automatically. Also re-applies gating and 2-in-1 coverage at the block level.
  function computeFinalRoutine() {
    var userPrefs = getUserPrefs(state.answers);
    var allConcerns = [];
    state.selectedAreas.forEach(function(area) {
      allConcerns = allConcerns.concat(getAreaConcerns(area, state.answers[area]));
    });
    allConcerns = uniq(allConcerns);

    var groups = [];

    ROUTINE_SLOTS.forEach(function(block) {
      if (state.selectedAreas.indexOf(block.requires.area) === -1) return;
      var sorted = block.slots.slice().sort(function(a, b) {
        return (a.step_order || 99) - (b.step_order || 99);
      });

      var items = [];
      var coveredCats = {};

      sorted.forEach(function(slot) {
        slot.area = block.requires.area;

        if (slot.skipIfCoveredByShampoo && coveredCats[slot.cat]) return;
        if (!slotPassesGate(slot, userPrefs, allConcerns)) return;

        var key = selectionKey(slot);
        if (!Object.prototype.hasOwnProperty.call(state.userSelections, key)) return;
        var product = state.userSelections[key];
        if (product == null) return;  // skipped by the user.

        if (slot.cat === 'shampoo' && product.is_all_in_one) {
          normArr(product.covers_slots).forEach(function(c) { coveredCats[c] = true; });
        }

        items.push({ slot: slot, product: product });
      });

      if (items.length) groups.push({ block: block, items: items });
    });

    return groups;
  }

  function renderResult() {
    state.phase = 'result';
    hide(qs('#rb-quiz'));
    show(qs('#rb-results'));
    updateProgress();

    var header = qs('#rb-results-header');
    if (header) {
      header.innerHTML =
        '<h1>Tu rutina personalizada 💪</h1>' +
        '<p>Basada en tus elecciones. Recuerda: consulta a un dermatólogo para condiciones específicas.</p>';
    }

    var body = qs('#rb-results-body');
    if (!body) return;
    body.innerHTML = '';
    state.recommendedVariants = [];

    var userPrefs = getUserPrefs(state.answers);
    var groups = computeFinalRoutine();
    var variantSet = {};

    groups.forEach(function(group) {
      var blockEl = el('div', 'rb-block');
      var headerEl = el('div', 'rb-block__header');
      var titleEl = el('h3', 'rb-block__title', group.block.emoji + '  ' + group.block.label);
      var divEl = el('span', 'rb-block__divider');
      headerEl.appendChild(titleEl);
      headerEl.appendChild(divEl);
      var stepsEl = el('div', 'rb-steps');

      group.items.forEach(function(item, idx) {
        stepsEl.appendChild(renderStepCard(item.slot, [item.product], idx + 1, userPrefs));
        if (item.product.available && item.product.variant_id && !variantSet[item.product.variant_id]) {
          variantSet[item.product.variant_id] = true;
          state.recommendedVariants.push(item.product.variant_id);
        }
      });

      blockEl.appendChild(headerEl);
      blockEl.appendChild(stepsEl);
      body.appendChild(blockEl);
    });

    if (body.children.length === 0) {
      body.innerHTML = '<p style="opacity:.6">No encontramos productos suficientes para tus preferencias. Estamos ampliando el catálogo.</p>';
    } else {
      // Summary banner with deduped product count + total. Inserted at the
      // top of the body so the user sees the total at a glance before scrolling
      // through individual blocks.
      var dedup = {};
      var total = 0, count = 0;
      groups.forEach(function (g) {
        g.items.forEach(function (it) {
          var p = it.product;
          if (!p || !p.variant_id || dedup[p.variant_id]) return;
          dedup[p.variant_id] = true;
          var n = parseFloat(p.price_raw);
          if (isFinite(n)) total += n;
          count++;
        });
      });
      var summary = el('div', 'rb-results__summary');
      var label = count === 1 ? 'producto en tu rutina' : 'productos en tu rutina';
      summary.innerHTML =
        '<span class="rb-results__summary-count">' + count + ' ' + label + '</span>' +
        '<span class="rb-results__summary-total">Total: S/ ' + total.toFixed(2) + '</span>';
      body.insertBefore(summary, body.firstChild);

      // Stagger the entry animation across step-cards. Cap delay at 300ms so
      // long routines don't make the user wait an absurd amount of time.
      var cards = body.querySelectorAll('.rb-step-card');
      for (var i = 0; i < cards.length; i++) {
        cards[i].style.animationDelay = Math.min(i * 50, 300) + 'ms';
      }
    }

    // Wire up action buttons (clone-and-replace removes prior listeners so re-entries stay idempotent).
    wireActionButton('#rb-add-all', addAllToCart, state.recommendedVariants.length > 0);
    wireActionButton('#rb-export-pdf', exportPdf, state.recommendedVariants.length > 0 || groups.length > 0);
    wireActionButton('#rb-restart', restartFlow, true);

    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function wireActionButton(sel, handler, visible) {
    var btn = qs(sel);
    if (!btn) return;
    if (!visible) { hide(btn); return; }
    show(btn);
    var clone = btn.cloneNode(true);
    btn.parentNode.replaceChild(clone, btn);
    clone.addEventListener('click', handler);
  }

  function restartFlow() {
    hide(qs('#rb-results'));
    show(qs('#rb-quiz'));
    state.phase = 'areas';
    state.selectedAreas = [];
    state.branchQueue = [];
    state.currentBranch = null;
    state.qIdx = 0;
    state.answers = {};
    state.recommendedVariants = [];
    state.slotQueue = [];
    state.slotIdx = 0;
    state.userSelections = {};
    renderAreas();
  }

  function renderStepCard(slot, products, displayStep, userPrefs) {
    var primary = products[0];
    var alts = products.slice(1);
    var card = el('div', 'rb-step-card' + (slot.optional ? ' rb-step-card--optional' : ''));

    var imgWrap = el('div', 'rb-step-card__img-wrap');
    if (primary.image) {
      var img = document.createElement('img');
      img.className = 'rb-step-card__img';
      img.src = primary.image; img.alt = primary.title; img.loading = 'lazy';
      imgWrap.appendChild(img);
    } else {
      imgWrap.appendChild(el('div', 'rb-step-card__img-placeholder', '📦'));
    }

    var badgeText = 'Paso ' + displayStep + ' · ' + slot.label;
    if (slot.optional) badgeText += ' (Opcional)';
    imgWrap.appendChild(el('span', 'rb-step-card__badge', badgeText));

    var bodyDiv = el('div', 'rb-step-card__body');
    bodyDiv.appendChild(el('h4', 'rb-step-card__title', primary.title));
    bodyDiv.appendChild(el('p', 'rb-step-card__price', primary.price));

    if (primary.key_ingredient) {
      bodyDiv.appendChild(el('p', 'rb-step-card__ingredient', '✦ ' + primary.key_ingredient));
    }
    if (primary.is_all_in_one) {
      bodyDiv.appendChild(el('p', 'rb-step-card__allinone', '💡 Producto 2-en-1: cubre shampoo y acondicionador.'));
    }

    var whyText = primary.why_recommended || buildAutoWhy(slot, primary, state.answers, userPrefs);
    if (whyText) bodyDiv.appendChild(el('p', 'rb-step-card__why', whyText));

    if (primary.medical_flag) {
      bodyDiv.appendChild(el('div', 'rb-medical-note',
        '⚠️ Contiene activos potentes. Si tienes piel reactiva, consulta a un dermatólogo.'));
    }

    // Frequency note (max_frequency from metafield overrides slot.note).
    var freq = primary.max_frequency;
    if (freq && freq !== 'diaria') {
      var freqLabel = ({
        '2_por_semana': 'Uso máximo: 2 veces por semana',
        '3_por_semana': 'Uso máximo: 3 veces por semana',
        'semanal':      'Uso máximo: 1 vez por semana',
      })[freq] || ('Frecuencia máxima: ' + freq);
      bodyDiv.appendChild(el('p', 'rb-step-card__note', freqLabel));
    } else if (slot.note) {
      bodyDiv.appendChild(el('p', 'rb-step-card__note', slot.note));
    }

    if (!primary.available) {
      bodyDiv.appendChild(el('p', 'rb-step-card__oos', 'Temporalmente agotado — te avisamos cuando vuelva.'));
    }

    var actions = el('div', 'rb-step-card__actions');
    var viewLink = document.createElement('a');
    viewLink.href = primary.url;
    viewLink.className = 'rb-step-card__link';
    viewLink.textContent = 'Ver producto →';
    actions.appendChild(viewLink);

    if (alts.length > 0) {
      var toggle = el('button', 'rb-step-card__alts-toggle',
        'Ver ' + alts.length + ' alternativa' + (alts.length > 1 ? 's' : ''));
      toggle.type = 'button';
      var altsPanel = renderAlts(alts);
      altsPanel.hidden = true;
      toggle.addEventListener('click', function() {
        altsPanel.hidden = !altsPanel.hidden;
        toggle.textContent = altsPanel.hidden
          ? 'Ver ' + alts.length + ' alternativa' + (alts.length > 1 ? 's' : '')
          : 'Ocultar alternativas';
      });
      actions.appendChild(toggle);
      bodyDiv.appendChild(actions);
      bodyDiv.appendChild(altsPanel);
    } else {
      bodyDiv.appendChild(actions);
    }

    card.appendChild(imgWrap);
    card.appendChild(bodyDiv);
    return card;
  }

  function renderAlts(products) {
    var panel = el('div', 'rb-alts');
    panel.appendChild(el('p', 'rb-alts__title', 'Alternativas'));
    products.forEach(function(p) {
      var item = el('div', 'rb-alt-item');
      if (p.image) {
        var img = document.createElement('img');
        img.className = 'rb-alt-item__img';
        img.src = p.image; img.alt = p.title; img.loading = 'lazy';
        item.appendChild(img);
      }
      var info = el('div', 'rb-alt-item__info');
      info.appendChild(el('span', 'rb-alt-item__title', p.title));
      info.appendChild(el('span', 'rb-alt-item__price', p.price));
      if (!p.available) info.appendChild(el('span', 'rb-alt-item__oos', 'Agotado'));
      item.appendChild(info);
      var link = document.createElement('a');
      link.href = p.url;
      link.className = 'rb-alt-item__link';
      link.textContent = 'Ver →';
      item.appendChild(link);
      panel.appendChild(item);
    });
    return panel;
  }

  /* ─── Cart ────────────────────────────────────────────────── */

  function addAllToCart() {
    var btn = qs('#rb-add-all');
    if (!btn || state.recommendedVariants.length === 0) return;
    btn.classList.add('rb-btn--loading');
    btn.disabled = true;
    btn.textContent = 'Agregando…';

    // Dedupe defensively — the same variant may appear in multiple blocks (e.g.
    // limpiador facial reused between AM and PM). Shopify aggregates duplicate
    // line-item IDs into a single quantity, which can exceed available stock.
    var seen = {};
    var items = [];
    state.recommendedVariants.forEach(function(id) {
      if (!id || seen[id]) return;
      seen[id] = true;
      items.push({ id: Number(id), quantity: 1 });
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items }),
    })
    .then(function(res) {
      return res.text().then(function(raw) {
        var data; try { data = JSON.parse(raw); } catch (e) { data = {}; }
        if (!res.ok) {
          var msg = data.description || data.message || ('HTTP ' + res.status);
          var err = new Error(msg);
          err.status = res.status;
          err.body = data;
          throw err;
        }
        return data;
      });
    })
    .then(function() { window.location.href = '/cart'; })
    .catch(function(err) {
      console.error('[Shotty RB] cart add failed:', err, 'items:', items);
      btn.classList.remove('rb-btn--loading');
      btn.disabled = false;
      var friendly = (err && err.status === 422)
        ? 'Stock insuficiente en alguno — reintenta'
        : 'Error – intenta de nuevo';
      btn.textContent = friendly;
      setTimeout(function() { btn.textContent = 'Agregar todo al carrito'; }, 3500);
    });
  }

  /* ─── Export PDF ──────────────────────────────────────────── */

  function exportPdf() {
    // Browser native print dialog — the @media print stylesheet in routine-builder.css
    // hides chrome and formats the routine for "Save as PDF".
    document.body.classList.add('rb-printing');
    var cleanup = function() {
      document.body.classList.remove('rb-printing');
      window.removeEventListener('afterprint', cleanup);
    };
    window.addEventListener('afterprint', cleanup);
    window.print();
  }

  /* ─── Init ────────────────────────────────────────────────── */

  // Live stock refresh: the static rb-catalog.json carries metafields (categories,
  // concerns, fragrances, etc.) which rarely change, but stock evolves daily as
  // products are sold or restocked. We hit Shopify's public /products/{handle}.js
  // endpoint per product (no auth, CDN-cached) to override `available`, `stock`
  // and `variant_id` with whatever the store reports right now. This way an
  // update to inventory in Shopify is reflected on the next page load — no
  // re-build of the static asset required.
  //
  // The fetches run in parallel and are best-effort: if any individual request
  // fails we keep the cached value. The whole batch is bounded by an 8s
  // timeout so a slow shop never blocks the quiz.
  var stockRefreshPromise = null;
  function refreshLiveStock() {
    if (stockRefreshPromise) return stockRefreshPromise;
    var products = window.SHOTTY_RB_PRODUCTS;
    if (!Array.isArray(products) || products.length === 0) {
      stockRefreshPromise = Promise.resolve();
      return stockRefreshPromise;
    }
    var ctrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { try { ctrl.abort(); } catch (e) {} }, 8000) : null;
    var jobs = products.map(function (p) {
      if (!p || !p.handle) return Promise.resolve();
      return fetch('/products/' + encodeURIComponent(p.handle) + '.js', {
        credentials: 'omit',
        signal: ctrl ? ctrl.signal : undefined,
      })
        .then(function (r) {
          if (r.status === 404) {
            // Product is not published to the Online Store sales channel — it
            // can't be bought. Force it out of recommendations regardless of
            // what the cached snapshot said.
            p.available = false;
            p.stock = 0;
            return null;
          }
          return r.ok ? r.json() : null;
        })
        .then(function (data) {
          if (!data) return;
          // Pick the variant that matches the cached variant_id when possible;
          // otherwise fall back to the first variant. Multi-variant products
          // are rare in this catalog but we want to track the right SKU.
          var variants = Array.isArray(data.variants) ? data.variants : [];
          var v = null;
          if (p.variant_id) v = variants.find(function (x) { return Number(x.id) === Number(p.variant_id); }) || null;
          if (!v) v = variants[0] || null;
          if (v) {
            // Storefront `available` already accounts for inventory_management
            // + inventory_policy. We trust this as the source of truth.
            var live = !!v.available;
            p.available = live;
            if (v.id) p.variant_id = v.id;
            if (typeof v.inventory_quantity === 'number') {
              // Some stores expose the live quantity; use it for sort/tiebreak.
              p.stock = v.inventory_quantity;
            } else if (live) {
              // Quantity hidden by Shopify (most common case for our store).
              // The cached stock may be a negative number from a previous
              // snapshot — but the variant is available right now. Mark stock
              // as unknown so the recommend() filter falls back to the
              // tolerant branch (p.stock == null) and lets the product pass.
              p.stock = null;
            } else {
              // Variant not available right now; keep stock at 0 to make the
              // filter explicit even if the cache held a positive value.
              p.stock = 0;
            }
          } else if (typeof data.available === 'boolean') {
            p.available = !!data.available;
            if (!data.available) p.stock = 0;
            else if (p.stock != null && p.stock <= 0) p.stock = null;
          }
        })
        .catch(function () { /* keep cached values on any error */ });
    });
    stockRefreshPromise = Promise.all(jobs).then(function () {
      if (timer) clearTimeout(timer);
    });
    return stockRefreshPromise;
  }

  function loadCatalog() {
    // Fetch catalog + contraindications in parallel. Catalog path stays
    // backward compatible (legacy inline also works).
    var catalogPromise;
    if (Array.isArray(window.SHOTTY_RB_PRODUCTS) && window.SHOTTY_RB_PRODUCTS.length) {
      catalogPromise = Promise.resolve();
    } else if (window.SHOTTY_RB_CATALOG_URL) {
      catalogPromise = fetch(window.SHOTTY_RB_CATALOG_URL, { credentials: 'omit' })
        .then(function(r) { if (!r.ok) throw new Error('fetch catalog failed: ' + r.status); return r.json(); })
        .then(function(data) {
          window.SHOTTY_RB_PRODUCTS = Array.isArray(data) ? data : [];
        })
        .catch(function(err) {
          console.error('[Shotty RB] catalog load failed:', err);
          window.SHOTTY_RB_PRODUCTS = [];
        });
    } else {
      catalogPromise = Promise.resolve();
    }

    var contrasPromise;
    if (Array.isArray(window.SHOTTY_RB_CONTRAINDICATIONS)) {
      contrasPromise = Promise.resolve();
    } else if (window.SHOTTY_RB_CONTRAINDICATIONS_URL) {
      contrasPromise = fetch(window.SHOTTY_RB_CONTRAINDICATIONS_URL, { credentials: 'omit' })
        .then(function(r) { if (!r.ok) throw new Error('fetch contras failed: ' + r.status); return r.json(); })
        .then(function(data) {
          window.SHOTTY_RB_CONTRAINDICATIONS = Array.isArray(data) ? data : [];
        })
        .catch(function(err) {
          console.error('[Shotty RB] contraindications load failed:', err);
          window.SHOTTY_RB_CONTRAINDICATIONS = [];
        });
    } else {
      window.SHOTTY_RB_CONTRAINDICATIONS = [];
      contrasPromise = Promise.resolve();
    }

    return Promise.all([catalogPromise, contrasPromise]);
  }

  // Wraps loadCatalog + the live stock hydration. Used both by the prewarm
  // and by the disclaimer accept handler so we can be sure stock is fresh
  // before the user picks a product.
  function loadCatalogAndStock() {
    return loadCatalog().then(refreshLiveStock);
  }

  function init() {
    var acceptBtn = qs('#rb-disclaimer-accept');
    if (!acceptBtn) return;
    acceptBtn.addEventListener('click', function() {
      loadCatalogAndStock().then(function() {
        var modal = qs('#rb-disclaimer');
        if (modal) modal.hidden = true;
        show(qs('#rb-quiz'));
        state.phase = 'areas';
        renderAreas();
      });
    });
    // Pre-warm the catalog fetch so it is ready by the time the user clicks.
    loadCatalogAndStock();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
